import { Quote } from "lucide-react";

export const About = () => {
  return (
    <section id="tietoa" className="bg-[#F3EFE7] py-16 sm:py-24">
      <div className="max-w-6xl mx-auto px-6 sm:px-8 grid lg:grid-cols-2 gap-12 lg:gap-16 items-center">
        <div className="order-2 lg:order-1">
          <div className="relative">
            <div className="absolute -inset-4 bg-[#245037]/10 rounded-[2rem] rotate-2" />
            <img
              src="https://images.pexels.com/photos/3823542/pexels-photo-3823542.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=650&w=940"
              alt="Digivili opastaa seniorimiestä älypuhelimen käytössä"
              className="relative rounded-[2rem] shadow-lg w-full h-[420px] object-cover"
            />
          </div>
        </div>

        <div className="order-1 lg:order-2">
          <span className="text-base font-bold text-[#245037] uppercase tracking-wide">
            Tarinani
          </span>
          <h2 className="mt-3 text-3xl sm:text-4xl font-bold tracking-tight text-[#1C1917]">
            Apua ihmiseltä, joka oikeasti välittää
          </h2>
          <p className="mt-6 text-lg sm:text-xl leading-relaxed text-[#44403C]">
            Aloitin urani vammaistyössä yli 10 vuotta sitten – autoin
            kehitysvammaisia ja senioreita heidän arjessaan. Työssäni huomasin,
            miten suuri tarve selkeälle ja henkilökohtaiselle teknologiaopastukselle
            oli.
          </p>
          <p className="mt-4 text-lg sm:text-xl leading-relaxed text-[#44403C]">
            Tämä oivallus johti minut perustamaan Digivilin – yrityksen, joka
            tarjoaa käytännönläheistä ja yksilöllistä tukea digipulmiin, jotta
            jokainen voi hyödyntää teknologiaa itsenäisesti ja luottavaisesti.
          </p>

          <blockquote className="mt-8 bg-white rounded-2xl p-6 border-l-4 border-[#245037] shadow-sm">
            <Quote className="w-8 h-8 text-[#E8C88A] mb-2" />
            <p className="text-lg font-semibold text-[#1C1917] italic">
              "Älä jää yksin teknisten haasteiden kanssa – olen täällä sinua varten.
              Löydetään yhdessä ratkaisut digipulmiisi."
            </p>
          </blockquote>
        </div>
      </div>
    </section>
  );
};
